import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import PublicLayout from '../layouts/PublicLayout';

const Terms = () => {
  return (
    <PublicLayout>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <Card className="shadow">
              <Card.Header className="bg-dark text-white">
                <h1 className="h3 mb-0">Terms of Use</h1>
              </Card.Header>
              <Card.Body className="bg-light">
                <p className="mb-4">
                  <strong>Effective Date:</strong> 5/27/2025
                </p>
                <p className="mb-4">
                  Welcome to Veritas Ratings ("Company," "we," "our," or "us").
                  These User Terms of Service (the "User Terms") govern your
                  access to and use of our website, application, and related
                  services (the "Services"). Whether you ("Customer") are
                  signing onto an existing account or creating an account for
                  the first time, by using the Services, these User Terms apply
                  to you —the prospective user reading these words. By clicking
                  to accept or agree to the User Terms of Service when this
                  option is made available to you, you accept and agree to be
                  bound and abide by these User Terms.
                </p>
                <p className="mb-4">
                  If you do not agree to these Terms, please do not use the
                  Service.
                </p>
                <p className="mb-4">
                  You understand that we may modify these terms from time to
                  time without notifying you in advance. You are encouraged to
                  regularly check the Effective Date above to see if these terms
                  have been modified since your last visit. When you use the
                  services, you are indicating your agreement to any
                  modification of these terms.
                </p>

                <h2 className="h4 mb-4 text-primary">BOTTOM LINE UP FRONT</h2>

                <h3 className="h5 mb-3">
                  These User Terms are Legally Binding
                </h3>
                <p>
                  By accessing or using our Service, you confirm that you are at
                  least 18 years of age, have the legal capacity to enter into
                  these Terms, and are not a minor in your jurisdiction. If you
                  are using the Service on behalf of another individual, you
                  confirm that you have their permission and legal authority to
                  do so.
                </p>
                <p className="mb-4">
                  We reserve the right to modify these Terms at any time.
                  Changes will take effect immediately once posted. Continued
                  use of the Service constitutes your acceptance of the modified
                  Terms.
                </p>

                <h3 className="h5 mb-3">Application of Consumer Law</h3>
                <p className="mb-4">
                  Veritas Ratings is a claims packet build tool intended for use
                  by military veterans and not for consumer purposes. To the
                  maximum extent permitted by law, you hereby acknowledge and
                  agree that consumer laws do not apply. If however any consumer
                  laws (e.g., in Australia, the Competition and Consumer Act
                  2010 (Cth)) do apply and cannot otherwise be lawfully
                  excluded, nothing in these User Terms will restrict, exclude
                  or modify any statutory warranties, guarantees, rights or
                  remedies you have, and our liability is limited (at our
                  option) to the replacement, repair or resupply of the
                  Services.
                </p>

                <h3 className="h5 mb-3">Intellectual Property Rights</h3>
                <p className="mb-4">
                  All content and features on the Service—text, graphics, logos,
                  software, and other materials—are owned or licensed by Veritas
                  Ratings and are protected under U.S. and international
                  intellectual property laws. You may not copy, distribute,
                  modify, or reproduce any part of our content without express
                  written consent.
                </p>

                <h3 className="h5 mb-3">User Representations</h3>
                <p>By using the Service, you represent and warrant that:</p>
                <ul>
                  <li>
                    All information you submit will be true, accurate, current,
                    and complete.
                  </li>
                  <li>
                    You will maintain and update such information as necessary.
                  </li>
                  <li>
                    You have the legal capacity and agree to comply with these
                    Terms of Use.
                  </li>
                  <li>You are not a minor in your jurisdiction.</li>
                  <li>
                    You will not access the Service using automated or non-human
                    means (e.g., bots, scripts).
                  </li>
                  <li>
                    You will not use the Service for any unlawful or
                    unauthorized purpose.
                  </li>
                  <li>
                    Your use of the Service will not violate any applicable law
                    or regulation.
                  </li>
                  <li>
                    You will cooperate with any requests from Veritas Ratings
                    regarding the submission of documentation, medical
                    evaluations, or administrative tasks needed to assist with
                    claims services.
                  </li>
                </ul>
                <p className="mb-4">
                  If you provide any false or incomplete information, or violate
                  these Terms, we reserve the right to suspend or terminate your
                  account and deny future access.
                </p>

                <h3 className="h5 mb-3">User Registration</h3>
                <p className="mb-4">
                  To use certain features, you must register for an account. You
                  are responsible for maintaining the confidentiality of your
                  login credentials and for all activities that occur under your
                  account. We enforce two-factor authentication (2FA) for added
                  security.
                </p>

                <h3 className="h5 mb-3">Prohibited Activities</h3>
                <p>You may not:</p>
                <ul>
                  <li>
                    Engage in unauthorized or unlawful use of the Service.
                  </li>
                  <li>Use the Service to impersonate or mislead.</li>
                  <li>
                    Interfere with the system's functionality or security.
                  </li>
                  <li>
                    Use data mining, scraping, or other automated data-gathering
                    tools.
                  </li>
                </ul>
                <p className="mb-4">
                  Violations may result in immediate account suspension or legal
                  action.
                </p>

                <h3 className="h5 mb-3">Services Provided</h3>
                <p>Veritas Ratings offers:</p>
                <ul>
                  <li>
                    Guidance on VA disability benefits strategy and
                    documentation.
                  </li>
                  <li>
                    Coordination with medical professionals for Disability
                    Benefits Questionnaires (DBQs).
                  </li>
                  <li>
                    Review of service and medical records, including DD214s.
                  </li>
                  <li>Claims tracking and submission support.</li>
                </ul>
                <p className="mb-4">
                  We are not affiliated with the U.S. Department of Veterans
                  Affairs (VA) and do not provide legal advice.
                </p>

                <h3 className="h5 mb-3">Medical and Legal Disclaimer</h3>
                <p className="mb-4">
                  The information provided by Veritas Ratings does not
                  constitute medical or legal advice. You should consult with a
                  licensed physician or an accredited VA attorney if you need
                  such services. Any results obtained using our Service are not
                  guaranteed, and requesting a reevaluation of your VA
                  disability rating may result in an increase, no change, or
                  even a decrease in your rating.
                </p>

                <h3 className="h5 mb-3">Privacy and Data Security</h3>
                <p className="mb-4">
                  We value your privacy. All personal and health-related data
                  you provide is handled in compliance with HIPAA regulations.
                  Our Privacy Policy explains how your information is collected,
                  stored, used, and shared.
                </p>

                <h2 className="h4 mb-4 text-primary">GENERAL PROVISIONS</h2>

                <h3 className="h5 mb-3">Termination of Use</h3>
                <p className="mb-4">
                  We may suspend or terminate your access to the Service at our
                  sole discretion for any violation of these Terms, or for
                  conduct that we believe is harmful to our operations, our
                  users, or third parties. You may request account deletion at
                  any time.
                </p>

                <h3 className="h5 mb-3">Limitation of Liability</h3>
                <p>
                  You agree that Veritas Ratings is not responsible or liable in
                  any way for any delay, denial, or outcome related to your VA
                  disability benefits claim. While we are committed to
                  supporting you through the process, we make no guarantee that
                  your claim will be approved, that your disability rating will
                  be increased, or that any specific outcome will be achieved.
                </p>
                <p>
                  We do not represent the Department of Veterans Affairs (VA)
                  and have no influence over VA decisions. Your success depends
                  on many factors, including but not limited to the medical
                  evidence provided, the accuracy of your records, and the VA's
                  own policies and discretion.
                </p>
                <p>By using our Service, you understand and accept that:</p>
                <ul>
                  <li>We are not liable for any decisions made by the VA.</li>
                  <li>
                    We are not liable for delays caused by the VA, third-party
                    providers, or outside agencies.
                  </li>
                  <li>
                    You accept full responsibility for any actions you take
                    based on the guidance, information, or recommendations we
                    provide.
                  </li>
                </ul>
                <p className="mb-4">
                  If you are dissatisfied with the outcome of your case or the
                  services rendered, you may request a review through our
                  internal appeal or service resolution process. Our goal is to
                  ensure fairness, transparency, and support throughout your
                  journey, even if outcomes are not what you hoped for.
                </p>

                <h3 className="h5 mb-3">Waiver</h3>
                <p className="mb-4">
                  No failure or delay by either party in exercising any right
                  under the User Terms will constitute a waiver of that right.
                  No waiver under the User Terms will be effective unless made
                  in writing and signed by an authorized representative of the
                  party being deemed to have granted the waiver.
                </p>

                <h3 className="h5 mb-3">Governing Law</h3>
                <p className="mb-4">
                  These User Terms, and any disputes arising out of or related
                  hereto, will be governed exclusively by the laws of the State
                  of Tennessee, without regard to its conflicts of laws rules or
                  the United Nations Convention on the International Sale of
                  Goods.
                </p>

                <h3 className="h5 mb-3">Venue; Waiver of Jury Trial; Fees</h3>
                <p className="mb-4">
                  The state and federal courts located in Williamson County,
                  Tennessee will have exclusive jurisdiction to adjudicate any
                  dispute arising out of or relating to these User Terms or
                  their formation as a contract between us or their enforcement.
                  Each party hereby consents and submits to the exclusive
                  jurisdiction of such courts.{' '}
                  <strong>
                    EACH PARTY ALSO HEREBY WAIVES ANY RIGHT TO JURY TRIAL IN
                    connection WITH ANY ACTION OR LITIGATION IN ANY WAY ARISING
                    OUT OF OR RELATED TO THE USER TERMS.
                  </strong>
                  In any action or proceeding to enforce rights under the User
                  Terms, the prevailing party will be entitled to recover its
                  reasonable costs and attorneys' fees.
                </p>

                <h3 className="h5 mb-3">Severability</h3>
                <p className="mb-4">
                  These User Terms will be enforced to the fullest extent
                  permitted under applicable law. If any provision of the User
                  Terms is held by a court of competent jurisdiction to be
                  contrary to law, the provision will be modified by the court
                  and interpreted so as best to accomplish the objectives of the
                  original provision to the fullest extent permitted by law, and
                  the remaining provisions of the User Terms will remain in
                  effect.
                </p>

                <h3 className="h5 mb-3">Survival</h3>
                <p className="mb-4">
                  The sections titled "Limitation of Liability" and "Survival",
                  and all of the provisions under the general heading "General
                  Provisions" will survive any termination or expiration of the
                  User Terms.
                </p>

                <h3 className="h5 mb-3">Assignment</h3>
                <p className="mb-4">
                  You may not assign any of your rights or delegate your
                  obligations under these User Terms whether by operation of law
                  or otherwise, without the prior written consent of us (not to
                  be unreasonably withheld). We may assign these User Terms in
                  their entirety (including all terms and conditions
                  incorporated herein by reference), without your consent, to a
                  corporate affiliate or in connection with a merger,
                  acquisition, corporate reorganization, or sale of all or
                  substantially all of our assets.
                </p>

                <h3 className="h5 mb-3">Entire Agreement</h3>
                <p className="mb-4">
                  The User Terms, including any terms incorporated by reference
                  into the User Terms, constitute the entire agreement between
                  you and us and supersede all prior and contemporaneous
                  agreements, proposals or representations, written or oral,
                  concerning its subject matter.
                </p>
                <p className="mb-4">
                  To the extent of any conflict or inconsistency between the
                  provisions in these User Terms and any pages referenced in
                  these User Terms, the terms of these User Terms will first
                  prevail; provided, however, that if there is a conflict or
                  inconsistency between the Contract and the User Terms, the
                  terms of the Contract will first prevail, followed by the
                  provisions in these User Terms, and then followed by the pages
                  referenced in these User Terms (e.g., the Privacy Policy).
                </p>

                <h2 className="h4 mb-4">12. Contact Information</h2>
                <p>
                  If you have any questions regarding these Terms of Use, you
                  can contact us at:
                </p>
                <ul>
                  <li>
                    <strong>Email:</strong> info@veritasratings.com
                  </li>
                  <li>
                    <strong>Phone:</strong> 615-961-0317
                  </li>
                  <li>
                    <strong>Mailing Address:</strong> 6640 Carothers Parkway
                    Suite 410, Franklin TN 37067
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </PublicLayout>
  );
};

export default Terms;
